import PropTypes from 'prop-types';
import CoCGraphViewer from '../CoCGraphViewer/cocGraphViewer';
import {statusIcons} from '../../../../../assets/svg';
import CoCAttachmentButton from '../CoCAttachmentButton/cocAttachmentButton';
import {validateFileType} from '../../utils/cocHelper';
import useLabels from 'infrastructure/js/hooks/useLabels';

import './cocAttachments.scss';


export default function CoCAttachments({
                                         index,
                                         name,
                                         isViewOnly = false,
                                         attachmentsCounters = [],
                                         attachmentsFiles = [],
                                         onAttachmentUpload = null,
                                         onAttachmentUploadValidation = null,
                                         onAttachmentRemove = null,
                                         onAttachmentClick = null,
                                         onAttachmentDownload = null,
                                         onAttachmentResultChange = null,

                                       }) {

  const labels = useLabels('mat.forms.cocTestForm.sectionListItem.attachments.');

  const onAttachmentChanged = (file, type) => {
    if (!validateFileType(file, type)) {
      return onAttachmentUploadValidation?.({ type: 'warning',
        title: labels.get('invalidFileType.title'),
        message: labels.get('invalidFileType.message'),
      });
    }
    const exists = attachmentsFiles.some(f => f.name === file.name);
    if (exists) {
      return onAttachmentUploadValidation?.(
        { type: 'warning',
          title: labels.get('duplicatedFile.title'),
          message: labels.get('duplicatedFile.message', '', {fileName: file.name}),
        });
    }

    onAttachmentUpload?.(file, type);
  }

  const renderRemoveFileButton = (item, itemIndex)  => {
    return isViewOnly ? null :
      (
        <span className="pl pl-x-input-close remove-attached-file-btn"
              onClick={(e) => onFileRemoveHandler(e, item, itemIndex)}/>
      );
  }

  const onFileRemoveHandler = (e, item, itemIndex) => {
    e.preventDefault();
    e.stopPropagation();

    const updatedList = attachmentsFiles.filter(it => it.id !== item.id);
    if (updatedList.length !== attachmentsFiles.length) {
      onAttachmentRemove?.(item);
    }
  }

  const onAttachmentClickHandler = (graph, itemIndex) => {
    onAttachmentClick?.(graph, itemIndex);
  }
  const onAttachmentDownloadHandler = (file) => {
    onAttachmentDownload?.(file);
  }

  const onGraphResultChange = (value, graph) => {
    onAttachmentResultChange?.(value, graph);
  }

  const attachedGraphs = attachmentsFiles.filter(f => f.type === 'GRAPH');
  const attachedOthers = attachmentsFiles.filter(f => f.type !== 'GRAPH');

  return (
    <div className="coc-attachments">

      {!!attachmentsCounters?.length &&
        <div className="attach-buttons-section">
          <span>{labels.get('attachFiles')}</span>
          {attachmentsCounters?.map((item, itemIndex) =>
            <CoCAttachmentButton key={itemIndex}
                                 id={`attach-btn-${item.type}-${index}`}
                                 {...item}
                                 disabled={isViewOnly}
                                 onAttachmentChanged={onAttachmentChanged}
            />)}
        </div>
      }

      {!!attachedOthers?.length && <div className="attached-files-section">
        {attachedOthers?.map((item, itemIndex) =>
          <div key={`${itemIndex}${item.id}`} className='attached-file' onClick={() => onAttachmentDownloadHandler(item)}>
            <span className='pl pl-file'/>
            <span className='file-name'>{item.name || item.file?.name}</span>
            {renderRemoveFileButton(item)}
          </div>
        )}
      </div>}

      {!!attachedGraphs?.length && <div className="attached-graphs-section">
        {attachedGraphs?.map((item, itemIndex) =>
          <div key={`${itemIndex}${item.id}`} className='attached-graph-item'>
            <div className='attached-graph-file' >
              <div className={item.isExpanded ? 'pl pl-arrow-down' : 'pl pl-arrow-right'} onClick={() => onAttachmentClickHandler(item)}/>
              <div className='attached-file' onClick={() => onAttachmentDownloadHandler(item)}>
                <span className='pl pl-file'/>
                <span className='file-name'>{item.name || item.file?.name}</span>
                {renderRemoveFileButton(item, itemIndex)}
              </div>
              {item.testResult === 'PASS' ? <statusIcons.statusPass/> : (item.testResult === 'FAIL' ? <statusIcons.statusFail/> : null)}
            </div>


            {item.isExpanded &&
              <CoCGraphViewer graph={item} index={itemIndex}
                              name={name}
                              isViewOnly={isViewOnly}
                              onGraphResultChange={onGraphResultChange}
              />}
          </div>
        )}
      </div>}
    </div>
  )
}

CoCAttachments.propTypes = {
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  attachmentsCounters: PropTypes.array,
  attachmentsFiles: PropTypes.array,
  onAttachmentUpload: PropTypes.func,
  onAttachmentUploadValidation: PropTypes.func,
  onAttachmentRemove: PropTypes.func,
  onAttachmentClick: PropTypes.func,
  onAttachmentDownload: PropTypes.func,
  onAttachmentResultChange: PropTypes.func,
}
